import Logo from '@app/assets/vertical-logo.svg?react';
import { Button } from '@app/components';
import { BusinessSelect } from '@app/components/BusinessSelect/BusinessSelect';
import { useSelectBusinessPage } from './SelectBusiness.hooks';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';

export const SelectBusiness = () => {
  const { businessState, businessIntegrationsMap/*, user*/ } = useSelectBusinessPage();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  // Handle new business parameter
  useEffect(() => {
    const isNewBusiness = searchParams.get('new');
    if (isNewBusiness === 'true') {
      // Remove the new parameter from URL
      navigate('/select-business', { replace: true });
      // Reload the page to ensure fresh data
      window.location.reload();
    }
  }, [searchParams, navigate]);

  return (
    <div className="flex items-center justify-start flex-col min-h-screen py-6 ">
      <Logo width={139} height={110} className="mb-4" />
      <div className="mb-auto space-y-6 max-w-[600px] w-full ">
        <div>
          <h2 className="font-bold text-3xl text-center">
            Select your business
          </h2>
          <p className="text-base-coolGray text-center">
            Select the business you are going to work on now
          </p>
        </div>
        <ul className="flex gap-4 flex-col max-w-[600px] w-full">
          {businessState?.list?.map((item, index) => (
            <li key={index}>
              <BusinessSelect {...item} integrations={businessIntegrationsMap[item.id] || []} />
            </li>
          ))}
        </ul>
        <div className="flex justify-center pt-8">
          <Button to="/select-business/create-new">Create new business</Button>
        </div>
      </div>
      {/*<pre style={{ border: 'solid 1px red', textAlign: 'left' }}>{JSON.stringify({ businessState, businessIntegrationsMap, user }, null, 4)}</pre>*/}
    </div>
  );
};
